/**
 * Allow only same-origin relative paths for post-login redirects.
 * Rejects protocol-relative URLs (//evil.com) and absolute external URLs.
 */
export function sanitizeSameOriginRedirect(path) {
  if (!path || typeof path !== "string") return "/";
  const trimmed = path.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return "/";
  try {
    const url = new URL(trimmed, window.location.origin);
    if (url.origin !== window.location.origin) return "/";
    if (url.pathname === "/login" || url.pathname === "/signup") return "/";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}
